<template>
	<div class="col">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" >

</style>